<main role="main" class="not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a
                href="javascript:void(0)"
                [routerLink]="['/']"
                routerLinkActive="router-link-active"
                >{{ "general.Accueil" | translate }}</a
              >
            </li>
            <li class="breadcrumb-item active">Configuration Recherche</li>
          </ol>
        </nav>
      </div>
      <div class="col-12">
        <button
          data-toggle="modal"
          data-target="#exampleModal"
          class="btn btn-primary"
          type="button"
          (click)="currentConfig = null; resetModal()"
        >
          Ajout d'un element
        </button>
      </div>

      <br />
      <br />
      <p>Liste des parametres de recherche</p>
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr>
            <th class="text-center" scope="col">Liste/Bibliothéque</th>
            <th class="text-center" scope="col">Type</th>
            <th class="text-center" scope="col">Champs Recherchable</th>
            <th class="text-center" scope="col">Titre Resultat</th>
            <th class="text-center" scope="col">Description Resultat</th>
            <th class="text-center" scope="col">Langue</th>
            <th class="text-center" scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listeParams">
            <td class="text-center">{{ item.Title }}</td>
            <td class="text-center">{{ item.TypeListe }}</td>
            <td>
              <ul>
                <li *ngFor="let lg of item.Champs">{{ lg }}</li>
              </ul>
            </td>
            <td class="text-center">{{ item.ResultsTitre }}</td>
            <td class="text-center">{{ item.ResultsDescription }}</td>
            <td>
              <ul>
                <li *ngFor="let lg of item.Langue">{{ lg }}</li>
              </ul>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)"
              (click)="resetModal();currentConfig = item; modifyConfig(item)"
              data-toggle="modal"
          data-target="#exampleModal"
                ><i width="30px" class="fa fa-edit fa-3"></i
              ></a>
              &nbsp;&nbsp;
              <a href="javascript:void(0)" (click)="RemoveConfig(item)">
                <i width="30px" class="fa fa-trash fa-3"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>

<!-- Button trigger modal -->
<!-- <button type="button" class="btn btn-primary" data-toggle="modal" id="showProfile" style='display: none;' data-target="#exampleModal">
    Demarrer le modal
  </button> -->

<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="margin: 10px">
        <h5
          class="modal-title"
          id="exampleModalLabel"
          *ngIf="currentConfig === null"
        >
          Configurer une nouvelle recherche
        </h5>
        <h5
          class="modal-title"
          id="exampleModalLabel"
          *ngIf="currentConfig !== null"
        >
          Modification d'un parametre de recherche
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          id="closeModal"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <br />
        <br />
        <div class="row">
          <div class="col-lg-2 col-md-2 col-sm-12"></div>
          <div class="col-lg-9 col-md-9 col-sm-12">
            <form class="rounded-form" action="" method="get">
              <div class="form-group d-flex" *ngIf="currentConfig === null">
                <select
                  class="form-control"
                  [(ngModel)]="selectedList"
                  name="listConfig"
                  id="listConfig"
                  (change)="getFieldsList()"
                >
                  <option value="0">
                    Selectionner un element de recherche
                  </option>
                  <option
                    *ngFor="let item of contenuNotSets; let index = index"
                    [value]="item.Id"
                  >
                    {{ item.Title }}
                  </option>
                </select>
              </div>
              <div class="form-group" *ngIf="currentConfig !== null">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                    <p>Nom Liste :</p>
                  </div>
                  <div class="col-lg-6 col-md-6 col-s-12">
                    {{selectedListTitle}}
                  </div>
                </div>
              </div>
              <div class="form-group" *ngIf="currentList !== null">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                    <p>Type Liste :</p>
                  </div>
                  <div class="col-lg-6 col-md-6 col-s-12">
                    {{ currentList.TypeListe }}
                  </div>
                </div>
              </div>
              <div class="form-group" *ngIf="currentList !== null">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                    <p>Langue :</p>
                  </div>
                  <div class="col-lg-6 col-md-6 col-s-12">
                    <ul>
                      <li *ngFor="let lg of currentList.Langue">{{ lg }}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                class="form-group"
                *ngIf=" currentList !== null &&
                  currentFields.length > 0 && currentList.TypeListe === 'Liste'
                "
              >
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                    <p>Champs recherchable :</p>
                  </div>
                  <div class="col-lg-6 col-md-6 col-s-12">
                    <mat-form-field>
                      <mat-label>Champs recherchable</mat-label>
                      <mat-select multiple name="rechercheFiled"  [(ngModel)]="currentRecherche">
                        <mat-option
                          *ngFor="let field of currentFields"
                          [value]="field.InternalName + ':' + field.TypeAsString"
                          >
                            {{ field.Title }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div
                class="form-group"
                *ngIf="
                  currentFields.length > 0
                "
              >
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                    <p>Titre resultat :</p>
                  </div>
                  <div class="col-lg-6 col-md-6 col-s-12">
                    <mat-form-field>
                      <mat-label>Titre Resultat</mat-label>
                      <mat-select name="TitreResultat" [(ngModel)]="currentTitle">
                        <mat-option
                          *ngFor="let field of currentFields"
                          [value]="field.InternalName + ':' + field.TypeAsString"
                        >
                          {{ field.Title }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div
                class="form-group"
                *ngIf="
                  currentFields.length > 0 
                "
              >
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                    <p>Description Resultat :</p>
                  </div>
                  <div class="col-lg-6 col-md-6 col-s-12">
                    <mat-form-field>
                      <mat-label>Description Resultat</mat-label>
                      <mat-select name="DescriptionResultat" [(ngModel)]="currentDescription">
                        <mat-option
                          *ngFor="let field of currentFields"
                          [value]="field.InternalName + ':' + field.TypeAsString"
                          >
                            {{ field.Title }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div
              class="form-group"
              *ngIf="
                currentFields.length > 0 
              "
            >
              <div class="row">
                <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
               
                </div>
                <div class="col-lg-6 col-md-6 col-s-12">
                  <a href="javascript:void(0)" (click)=" SaveConfig()"><i title="Save" class="fa fa-save"></i></a>
                  &nbsp;
                  <a href="javascript:void(0)"><i  title="Annuler" class="fa fa-undo"></i></a>
                </div>
              </div>
            </div>
            </form>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-12"></div>
        </div>
      </div>
    </div>
  </div>
</div>
